<template>
    <v-row dense justify="center" class="StatisticsProviders pa-6">
        <!-- Aller bosse maintenant ! -->
    </v-row>
</template>

<script>
export default {
    name: "StatisticsProviders",
    components: {

    },
    data() {
        return {
            
        }
    },
    destroyed() {
        
    },
    methods: {

    },
    created() {
        
    },
}
</script>

<style lang="scss">
    .StatisticsProviders {

    }
</style>